import Button from "./Button.jsx";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faQuestionCircle} from "@fortawesome/free-solid-svg-icons";

const URL_PREFIX = 'https://datixo.freshdesk.com/support/solutions/articles/';

export default function SupportLink({title, articleId}) {
    return <Button
        onClick={() => window.open(URL_PREFIX + articleId, '_blank')}
        variant={'outline-cyan'}
    >
        <div className={'flex gap-2'}>
            <FontAwesomeIcon icon={faQuestionCircle} className={'text-xl'}/>
            <div>{title}</div>
        </div>
    </Button>;
}